import React from "react";

// Sfondo oscurato dietro le tendine della barra in alto. Le tendine della barra in basso (Rispondi / AI)
// disegnano il proprio sfondo DENTRO la barra (vedi BottomToolbar): così tasti e tendina restano in primo
// piano su ogni browser, anche iOS Safari/PWA che non ordina bene gli z-index tra contenitori scrollabili ed elementi fixed.
export default function Oscuramento({ onClick, testid, menu }) {
  if (/-(reply|ai)$/.test(menu || "")) return null;
  return <div className="dd-backdrop" onClick={onClick} data-testid={testid} />;
}
